import { HTMLAttributes } from "react"
import { FileExtension } from "@nova/constants"
import { DropBoxV2 } from "panels/content/top-bar/TODO-put-in-package/dropbox/DropBoxV2"
import classNames from "classnames"

export const UploadDropBox = (
    props: {
        canAcceptMultiple?: boolean
        allowedFileExtensions: FileExtension[]
        onNewItems: (files: File[]) => void
        isProcessing: boolean
        maxFileSizeInMB: number
    } & HTMLAttributes<HTMLDivElement>
) => {
    return (
        <DropBoxV2
            {...props}
            className={classNames(
                "w-[15.875rem] p-2 rounded-xl bg-black-900 border border-white-300 shadow-card",
                props.className
            )}
        />
    )
}
